import axios from "axios";
import {
  isEmpty
} from "lodash-es";
import {
  getAccessToken,
  getCompanyToken,
  getRefreshToken,
  tokenRefresh
} from "../apis/auth";
import {
  viewLoading
} from "./loading";
import systemAlert from "./systemAlert";

import {
  isExpires
} from "./token";
import $ from 'jquery'
import {
  toast
} from "./toast";
import {
  get
} from "lodash";
import {
  isTestCompany
} from "./auth";
import {
  testRequest
} from "../test-apis/test-request";
import {
  testResponse
} from "../test-apis/test-response";

export const {
  REACT_APP_API_URL: API_URL
} = process.env;

const http = axios.create({
  baseURL: API_URL,
  headers: {
    "Cache-Control": "no-cache"
  },
});

const promiseList = []

http.interceptors.request.use(
  async function(config) {
    const isExpired = isExpires(getAccessToken())
    // 토큰 만료인경우
    if (isExpired && isEmpty(promiseList)) {
      viewLoading(true)
      // 리프레쉬 토큰 만료 여부
      const isExpired = isExpires(getRefreshToken())
      if (isExpired) {
        systemAlert('토큰이 만료되었습니다.\n 다시 로그인 해주세요.')
        viewLoading(false)
        window.location.href = '/logout'
        return
      } else {
        promiseList.push(
          new Promise((resolve, reject) => {
            tokenRefresh()
              .then(() => {
                resolve()
              })
              .catch(() => {
                reject()
                systemAlert('토큰을 갱신할수 없습니다.\n 다시 로그인 해주세요.')
                window.location.href = '/logout'
              })
              .finally(() => {
                viewLoading(false)
                do { } while (promiseList.pop());
              })
          })
        )
      }
    }
    await Promise.all(promiseList)
    const companyToken = getCompanyToken();
    config.headers.Authorization = getAccessToken();
    if (!isEmpty(companyToken)) {
      config.headers.companytoken = companyToken;
    }
    return isTestCompany() ? testRequest(config) : config;
  },
  function(error) {
    return Promise.reject(error);
  }
);
let isMessage = false

http.interceptors.response.use(
  function(response) {
    return isTestCompany() ? testResponse(response) : response;
  },

  function(error) {
    try {

      // 권한별 에러처리 필요
      const statusCode = Number(get(error, 'response.status', 999))
      const message = get(error, 'response.data.message', "유효하지 않은 토큰입니다.")

      if (
        statusCode === 401
      ) {
        if (!isMessage) {
          isMessage = true
          systemAlert(message, {
            buttons: [{
              label: '확인',
              onClick: () => {
                isMessage = false
                window.location.href = '/logout'
              }
            }]
          })
        }
        // } else if (
        //   statusCode === 404
        // ) {
        //   isMessage = true
        //   systemAlert("해당 API 를 찾을 수 없습니다..", {
        //     buttons: [{
        //       label: '확인',
        //       onClick: () => {
        //         isMessage = false
        //       }
        //     }]
        //   })
      } else if (
        statusCode === 403 || statusCode === 404
      ) {
        if (!isMessage) {
          isMessage = true
          systemAlert("세션이 만료되어 로그인 화면으로 이동됩니다.", {
            buttons: [{
              label: '확인',
              onClick: () => {
                isMessage = false
                window.location.href = '/logout'
              }
            }]
          })
        }

      } else if (
        statusCode === 400
      ) {
        toast.warning(`요청에 실패 했습니다. <br />[${statusCode}] : ${get(error, 'response.data.message', '잘못된 요청시도, 관리자에게 문의해주세요.')}`);
      } else {

        let errMsg = get(error, 'response.data.outJson.errMsg')
        if (!errMsg) {
          errMsg = get(error, 'response.data.message', '잘못된 요청시도, 관리자에게 문의해주세요.')
        }
        toast.error(`실패했습니다. 관리자에게 문의해주세요.<br />[${statusCode}] : ${errMsg}`);
      }
      return Promise.reject(error);
    } catch (err) {

      if (isTestCompany()) {
        // TEST error response
      }
    }
  }
);

const noneTokenHttp = axios.create({
  baseURL: API_URL
});

noneTokenHttp.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.reject(error);
  }
);

noneTokenHttp.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const errorMessage = get(error, 'response.data.message')
    if (errorMessage) {
      toast.error(errorMessage)
    }
    return Promise.reject(error);
  }
);

const crossAjax = (options) => {
  $.ajax({
    type: "POST",
    dataType: "json",
    contentType: "application/json; charset=UTF-8",
    crossDomain: true,
    crossOrigin: true,
    success: function(data) { },
    error: function(xhr, status, err) {
      alert(err)
    },
    ...options
  });
}

export default http;
export {
  noneTokenHttp,
  http,
  crossAjax
};